import React, { useState, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { Form, Button, Icon, Collapse, Card, Descriptions, Alert } from 'antd';
import { EbPageLoader } from '../../Common';
import { EASEBUZZ_PS_LOGO_COLOR } from '../../../constants';
import { Beneficiary } from '../../../models';
import { MerchantService } from '../../../services';
import { handleApiExceptions, printRupee, generate_query_set } from '../../../app_methods';
import { Text2, Text3} from '../../../styles';
import moment from 'moment';
import "./index.scss";
import ReCAPTCHA from 'react-google-recaptcha';
import { TransferRequestApproval } from '../../../models';

const recaptchaRef = React.createRef()

const ApproveTransferRequestForm = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const { validations } = Beneficiary;

    const [isLoading, setIsLoading] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [approval, setApproval] = useState({});
    const [isAuthenticating, setIsAuthenticating] = useState(false);
    const [OTPSent, setOTPSent] = useState(false);
    const [activePanel, setActivePanel] = useState("0");
    const [captcha, setCaptcha] =  useState(false)
    const [reCaptchaResponse, setRecaptchaResponse] = useState('')
    const [user, setUser] = useState({})
    const [userApproved, setUserApproved] = useState(false);
    const [error, setError] = useState('');
    const [requested, setRequested] = useState('');

    const authInput = useRef(null);


    const getApprovalInfo = () => {
        MerchantService.get_approval_info({
            approval_id: props.match.params.approval_id,
            user_id: props.match.params.user_id
        }).then(response => {
            if (response.success) {
                setActivePanel("1");
                setApproval(response.data.approval);
                setUser(response.data.user);
                setUserApproved(response.data.user_approved);
                setError('');
                setIsMounted(true);
            }
            else {
                setIsMounted(true);
                setError(response.message || "Something went wrong! Please try again.")
//                 handleApiExceptions(response);
            }
        }).catch(error => {
            setIsMounted(true);
            setError("Something went wrong! Please try again.")
//             handleApiExceptions("Something went wrong! Please try again.");
        });
    };



    const approveRequest = async (declined=false) => {
            setIsLoading(true);
            setRequested(declined?'declined':'approved')
           MerchantService.approve_request({
                approval_id: approval.id,
                user_id: user.uuid,
                declined: declined
            }).then(response => {
            setRequested('')
                if (!response.success) {
                    handleApiExceptions(response.message);
                    setIsLoading(false);
                    return;
                }
                setIsLoading(false);
                setApproval(response.data.approval);
                setUser(response.data.user);
                setUserApproved(response.data.user_approved);
            }).catch(error => {
            setRequested('')
                setIsLoading(false);
                handleApiExceptions("Something went wrong! Please try again.");
            });
    }


    const renderForm = () => {
        return (
                <>
                <Button className="w-100 mt-2 mb-2" type="primary" disabled={isLoading} loading={requested == 'approved'} htmlType="submit" onClick={() => approveRequest(false)} ghost>Approve</Button>
                <Button className="w-100" type="danger" htmlType="submit" disabled={isLoading} loading={requested == 'declined'} onClick={() => approveRequest(true)} ghost>Reject</Button>
                </>
        )
    }

    const handleCaptcha = (key) => {
          setCaptcha(true);
          setRecaptchaResponse(key);
          getApprovalInfo();
    }

    const captchaSubmit = () => {
        setIsAuthenticating(true);
          if(captcha){
            let data = {
              'g-recaptcha-response': reCaptchaResponse
            }
            MerchantService.verify_captcha(data).then(response => {
                    setIsAuthenticating(false);
                    if (response.success) {
                        setActivePanel("1")
                    }
                    else {
                        handleApiExceptions("Captcha not verified. Please try again");
                    }
                    setIsAuthenticating(false);
                }).catch(error => {
                    handleApiExceptions("Something went wrong! Please try again.");
                });
          }
          setIsAuthenticating(false);
        //To reset captcha
        recaptchaRef.current.reset()
    }


    const renderAuthentication = () => {
        return (
            <div>
                <form onSubmit={captchaSubmit} >
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6Ld6bTgUAAAAAA6oCjg5ABKApovAVcIBARo2Neri"
                    onChange={handleCaptcha}
                  />
                </form>
            </div>

        )
    };

    const renderPage = () => {
        return (
            <Card className="payout-attempt-card-wrapper" style={{height: "fit-content"}}>
                <div className="payout-attempt-card d-flex justify-content-between">
                    {!isMounted?
                    <div className="verify_alert">
                    <Alert
                    type="info"
                    className=""
                    message=""
                    showIcon
                    style={{ borderRadius: 10 }}
                    description="Please verify Captcha to proceed"
                    /> </div>: null}
                    <div className={"details-wrapper"} style={{ maxWidth: 500 }}>
                        <div className={isMounted && error == ''? "": "blur"}>
                            <div className="mb-1"><Text2>{isMounted? approval.requested_by: 'xxxxxx'}</Text2><Text3> has initiated a transfer which requires your approval. Please refer to the following details.</Text3></div>
                                <Descriptions className="mb-4 mt-2" title="" column={1} size="small" bordered>
                                    <Descriptions.Item label="Amount">{isMounted && error == ''? printRupee(approval.amount) || "---" : 'XXXXX'}</Descriptions.Item>
                                    <Descriptions.Item label="Beneficiary Name">{isMounted && error == ""? approval.transfer_request.beneficiary_account_name || "---" : 'XXXXX'}</Descriptions.Item>
                                    {!isMounted || error != ''?<Descriptions.Item label="Account Number">XXXXX</Descriptions.Item>: null}
                                    {!isMounted || error != ''?<Descriptions.Item label="IFSC Code">XXXXX</Descriptions.Item>: null}
                                    {!isMounted || error != ''?<Descriptions.Item label="Bank Name">XXXXX</Descriptions.Item>: null}
                                    {
                                        approval.transfer_request ?
                                        approval.transfer_request.beneficiary_upi_handle ?
                                        <Descriptions.Item label="UPI Handle">{approval.transfer_request.beneficiary_upi_handle || "---"}</Descriptions.Item>
                                        :
                                        <>
                                                    <Descriptions.Item label="Account Number">{approval.transfer_request.beneficiary_account_number || "---"}</Descriptions.Item>
                                                    <Descriptions.Item label="IFSC Code">{approval.transfer_request.beneficiary_account_ifsc || "---"}</Descriptions.Item>
                                                    <Descriptions.Item label="Bank Name">{approval.transfer_request.beneficiary_bank_name || "---"}</Descriptions.Item>
                                                </>
                                            :null
                                    }
                                    <Descriptions.Item label="Narration">{isMounted && error == ""? approval.transfer_request.narration || "---" : 'XXXXX'}</Descriptions.Item>
                                </Descriptions>
                                {error == '' && approval.status == "approved" || approval.status == "rejected" || userApproved ? renderInfo() : null}
                        </div>
                        {error != ''?
                        <Alert
                        type="error"
                        className=""
                        message=""
                        showIcon
                        style={{ borderRadius: 10 }}
                        description={error}
                        /> : null}
                    </div>
                    <Card className="attempt-form" style={{width: "100%", maxWidth: isMobile?'-webkit-fill-available':"380px"}}>
                        <Collapse accordian={true} activeKey={activePanel} collapsible={false}>
                            <Collapse.Panel showArrow={false} key="0" header={<Text3>1. Captcha Verification  {activePanel == "1" ? <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /> : null}</Text3>}>
                                {renderAuthentication()}
                            </Collapse.Panel>
                            <Collapse.Panel showArrow={false} key="1" header={<Text3>2. Approval Request</Text3>}>
                                <>
                                {approval.status != "approved" && approval.status != "rejected" && !userApproved? <>Approve/Reject the request {renderForm()}</>: <>No actions required</>}
                                </>
                            </Collapse.Panel>
                        </Collapse>
                    </Card>
                </div>
            </Card>
        )
    };

    const renderLoader = () => {
        return (
            <div
                style={{
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <EbPageLoader />
            </div>
        )
    };

    const renderInfo = () => {
        let infoStatus = "error";
        let infoTitle = "Oops!!!";
        let infoSubtitle = "Something went wrong.";

        if (approval.status == "approved" || userApproved) {
            infoStatus = "success";
            infoTitle = "Request Approved";
            infoSubtitle = "Fund transfer request has been approved successfully.";
        }
        else if (approval.status == "rejected") {
            infoStatus = "error";
            infoTitle = "Request Rejected";
            infoSubtitle = "Fund transfer request has been rejected.";
        }

        return (
                <Alert
                    type={approval.status == "approved" || userApproved ? "success": "error"}
                    className="mb-2"
                    message={infoTitle}
                    showIcon
                    style={{ borderRadius: 10 }}
                    description={infoSubtitle}
                />
            )
    };


    const renderLogo = () => {
        return (
            <div className="footer-logo-wrapper">
                <span className="mr-2" style={{ fontSize: 15 }}>Powered by:</span>
                <div style={{ width: 115, height: "auto", overflow: "hidden", textAlign: "center", maxHeight: 65 }}>
                    <img style={{ margin: "auto", width: "auto", maxWidth: "100%", maxHeight: 65 }} alt="" src={EASEBUZZ_PS_LOGO_COLOR} />
                </div>
            </div>
        )
    }


    return (
        <div className="payout-attempt-page-wrapper">
            { renderPage() }
            { renderLogo() }
        </div>

    )
};

const PayoutLinkPaymentAttempt = Form.create()(ApproveTransferRequestForm);

export default PayoutLinkPaymentAttempt;
